import React from "react";
const Title = ({ children, size }) => {
  const _size = size ? size : "1.5rem";
  return (
    <span
      style={{
        fontWeight: "bold",
        fontSize: _size,
        margin: "1rem",
        padding: "0px",
        // whiteSpace: "nowrap",
        // overflow: "hidden",
        // textOverflow: "ellipsis",
      }}
      title={children}
    >
      {children}
    </span>
  );
};

export default Title;
